import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import NavBar from "../components/NavBar";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const { user } = useAuth();
  const nav = useNavigate();
  const [status, setStatus] = useState("checking");
  const [attempts, setAttempts] = useState(0);

  const sessionId = params.get("session_id");
  const orderId = params.get("order_id");

  useEffect(() => {
    if (!user) { nav("/login"); return; }
    if (!sessionId) { setStatus("error"); return; }
    let cancelled = false;
    const poll = async (n = 0) => {
      if (cancelled) return;
      if (n >= 8) { setStatus("timeout"); return; }
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        setAttempts(n + 1);
        if (r.data.payment_status === "paid") { setStatus("paid"); return; }
        if (r.data.status === "expired") { setStatus("expired"); return; }
      } catch (err) {
        console.warn("Payment status poll failed (will retry):", err?.message || err);
      }
      setTimeout(() => poll(n + 1), 2000);
    };
    poll(0);
    return () => { cancelled = true; };
    // eslint-disable-next-line
  }, [sessionId, user]);

  return (
    <div data-testid="payment-success-page">
      <NavBar />
      <div className="max-w-2xl mx-auto px-6 py-20 text-center">
        <div className="label-eyebrow mb-4">CHECKOUT / RETURN</div>
        {status === "checking" && (
          <>
            <h1 className="font-display text-4xl font-black uppercase">Confirming your payment…</h1>
            <p className="ribbon text-black/60 mt-4">Attempt {attempts + 1} of 8</p>
          </>
        )}
        {status === "paid" && (
          <>
            <h1 className="font-display text-4xl font-black uppercase">Payment confirmed.</h1>
            <p className="mt-4 text-black/70">Submit your intake details to start the report.</p>
            <Link to={orderId ? `/orders/${orderId}` : "/dashboard"} className="btn btn-primary mt-8"
                  data-testid="ps-go-order">
              Go to order →
            </Link>
          </>
        )}
        {status === "expired" && (
          <>
            <h1 className="font-display text-4xl font-black uppercase">Session expired.</h1>
            <Link to="/dashboard" className="btn btn-primary mt-8">Try again</Link>
          </>
        )}
        {(status === "timeout" || status === "error") && (
          <>
            <h1 className="font-display text-4xl font-black uppercase">Status still pending</h1>
            <p className="mt-4 text-black/70">Your dashboard will update shortly. You can check on the order page.</p>
            <Link to="/dashboard" className="btn btn-primary mt-8" data-testid="ps-dashboard">Open dashboard</Link>
          </>
        )}
      </div>
    </div>
  );
}
